import React, { useState } from "react";
import PrimingScreen from "./components/PrimingScreen";
import FormWizard from "./components/FormWizard";
import ThankYouPage from "./components/ThankYouPage";
import NavBar from "./components/NavBar";
import { ToastManager } from "./components/ToastNotification";

function App() {
  const [currentScreen, setCurrentScreen] = useState("priming");
  const [submissionData, setSubmissionData] = useState(null);

  const handleStartForm = () => {
    setCurrentScreen("form");
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
  };

  const handleFormSubmit = (data) => {
    setSubmissionData(data);
    setCurrentScreen("complete");
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
  };

  const renderScreen = () => {
    switch (currentScreen) {
      case "priming":
        return <PrimingScreen onStart={handleStartForm} />;
      case "form":
        return <FormWizard onSubmit={handleFormSubmit} />;
      case "complete":
        return <ThankYouPage data={submissionData} />;
      default:
        return <PrimingScreen onStart={handleStartForm} />;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-secondary-50">
      <NavBar />
      {renderScreen()}
      <ToastManager />
    </div>
  );
}

export default App;
